import NotAllowed from "../../../../../components/error/not-allowed";
import { Permission } from "../../../../permission";
import { PERMISSIONS } from "../../../../role-control/constants";
import AbsenceLetterDetail from "../../absence-letter/pages/absence-letter/absence-letter-detail";
import { SickLeaveCreate, SickLeaveEdit, SickLeaveList } from "../../absence-letter/pages/sick-leave";

export const sickLeaveDADRoutes = {
  sickLeaveDADPage: {
    isAdmin: false,
    title: "3. Nghỉ ốm/nuôi con ốm",
    path: "/procedure/sick-leave-dad",
    parentId: "procedure",
    component: () => {
      return (
        <SickLeaveList />

        // <Permission record={{ [PERMISSIONS["SICK_LEAVE_DAD"]]: ({ R }) => R }} fallback={<NotAllowed />}>
        //   <SickLeaveList />
        // </Permission>
      );
    },
  },
  createSickLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/sick-leave-dad/create",
    parentId: "procedure",
    component: SickLeaveCreate,
  },
  detailSickLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/sick-leave-dad/:applicationForLeaveId",
    parentId: "procedure",
    component: AbsenceLetterDetail,
  },
  editSickLeaveDADPage: {
    isAdmin: false,
    path: "/procedure/sick-leave-dad/:applicationForLeaveId/edit",
    parentId: "procedure",
    component: SickLeaveEdit,
  },
};
